import { render, staticRenderFns } from "./NavbarMobileAccordion.vue?vue&type=template&id=48f96978&scoped=true&lang=pug&"
import script from "./NavbarMobileAccordion.vue?vue&type=script&lang=js&"
export * from "./NavbarMobileAccordion.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMobileAccordion.vue?vue&type=style&index=0&id=48f96978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f96978",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f96978')) {
      api.createRecord('48f96978', component.options)
    } else {
      api.reload('48f96978', component.options)
    }
    module.hot.accept("./NavbarMobileAccordion.vue?vue&type=template&id=48f96978&scoped=true&lang=pug&", function () {
      api.rerender('48f96978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/NavbarMobileAccordion.vue"
export default component.exports